import React from "react"
import { Link } from "gatsby"
import gmailIcon from "../img/gmail-icon.png"

export default class Footer extends React.Component {
  render() {
    return (
      <div className="bg-white border-t border-gray-200">
        <div className="max-w-screen-xl py-12 mx-auto md:flex md:items-center md:justify-between">
          <div className="">
            <nav className="flex justify-center -my-2">
              <div className="px-3 py-2">
                <Link
                  to="/"
                  className="text-base leading-6 text-gray-900 hover:text-gray-500"
                >
                  Home
                </Link>
              </div>
              <div className="px-5 py-2">
                <Link
                  to="/blog/"
                  className="text-base leading-6 text-gray-900 hover:text-gray-500"
                >
                  Blog
                </Link>
              </div>
              <div className="px-5 py-2">
                <Link
                  to="/about/"
                  className="text-base leading-6 text-gray-900 hover:text-gray-500"
                >
                  About
                </Link>
              </div>
              <div className="px-5 py-2">
                <Link
                  to="/contact/"
                  className="text-base leading-6 text-gray-900 hover:text-gray-500"
                >
                  Contact
                </Link>
              </div>
            </nav>
          </div>

          <div className="flex justify-center mt-10 lg:mt-0 md:mt-0 md:order-2">
            <a
              href="https://www.facebook.com/enjoyalgorithms"
              className="text-gray-400 hover:text-gray-500"
            >
              <img
                src="https://img.icons8.com/color/50/000000/facebook.png"
                className="w-8 h-8"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/enjoy-algorithms/"
              className="ml-6 text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">Linkedin</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="50"
                height="50"
                viewBox="0 0 48 48"
                className="w-8 h-8"
              >
                <path
                  fill="#0288D1"
                  d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
                ></path>
                <path
                  fill="#FFF"
                  d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
                ></path>
              </svg>
            </a>
            <a
              href="https://medium.com/enjoy-algorithm"
              className="ml-6 mt-0.5 text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">Medium</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="50"
                height="50"
                viewBox="0 0 50 50"
                className="w-7 h-7"
              >
                {" "}
                <path d="M45,4H5C4.448,4,4,4.448,4,5v40c0,0.552,0.448,1,1,1h40c0.552,0,1-0.448,1-1V5C46,4.448,45.552,4,45,4z M40,13.5 l-1.821,2.197C38.064,15.811,38,15.965,38,16.125V32.75c0,0.16,0.064,0.314,0.179,0.428L40,35.546V36H30v-0.454l2.821-2.368 C32.936,33.064,33,32.91,33,32.75V17.879L24.848,36h-0.001h-1.543l0,0L15,18.375v13.108c0,0.22,0.076,0.433,0.215,0.605L18,35.546 V36h-8v-0.454l2.783-3.438C12.923,31.936,13,31.721,13,31.5V16.388c0-0.142-0.05-0.279-0.142-0.388L11,13.5V13h7.097l7.624,16.183 L33.002,13H40V13.5z"></path>
              </svg>
            </a>
            {/* <a
              href="https://www.contact@enjoyalgorithms.com"
              className="ml-6 text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">Gmail</span>
              <img src={gmailIcon} className="w-7 h-7" />
            </a> */}
          </div>

          <div className="mt-8 mr-0 lg:mr-20 md:mt-0 md:order-1">
            <p className="text-base leading-6 text-center text-gray-400">
              © 2020 EnjoyAlgorithms, Inc. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    )
  }
}
